import { create } from "zustand";
import {
  type IBillData,
  type IOverviewJointBillService,
} from "@services/overview/types";

interface IMeterReadingError {
  billDetailId: number;
  fieldName: string;
  text: string;
}

interface IBillError {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
  billId: IBillData["billId"];
  fieldName: string;
  text: string;
}

interface IJointBillErrorsStore {
  meterReadingErrors: IMeterReadingError[];
  setMeterReadingErrors: (invalidBillDetails: IMeterReadingError[]) => void;
  clearMeterReadingErrors: () => void;
  billNumberErrors: IBillError[];
  setBillNumberErrors: (invalidBillDetails: IBillError[]) => void;
  clearBillNumberErrors: () => void;
}

export const useJointBillErrorsStore = create<IJointBillErrorsStore>((set) => ({
  meterReadingErrors: [],
  setMeterReadingErrors: (meterReadingErrors) => set({ meterReadingErrors }),
  clearMeterReadingErrors: () => set({ meterReadingErrors: [] }),
  billNumberErrors: [],
  setBillNumberErrors: (billNumberErrors) => set({ billNumberErrors }),
  clearBillNumberErrors: () => set({ billNumberErrors: [] }),
}));
